import script from "./PostText.vue?vue&type=script&lang=ts"
export * from "./PostText.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__